import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent as MuiDialogContent,
  Grid,
  Typography,
} from "@mui/material";
import styled from "styled-components/macro";
import { spacing } from "@mui/system";

const DialogContent = styled(MuiDialogContent)(spacing);

const useConfirm = (message) => {
  const [promise, setPromise] = useState(null);

  const confirm = () =>
    new Promise((resolve, reject) => {
      setPromise({ resolve });
    });

  const handleClose = () => {
    setPromise(null);
  };

  const handleConfirm = () => {
    promise?.resolve(true);
    handleClose();
  };

  const handleCancel = () => {
    promise?.resolve(false);
    handleClose();
  };
  // You could replace the Dialog with your library's version
  const ConfirmationDialog = () => (
    <Dialog open={promise !== null}>
      <DialogContent sx={{ maxWidth: "520px" }} px={40} py={15}>
        <Grid container spacing={8} justifyContent="center">
          <Grid item xs={12}>
            <Typography variant="h5" textAlign="center">
              {message}
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Grid container spacing={5} justifyContent="center">
              <Grid item xs="auto">
                <Button color="primary" onClick={handleCancel}>
                  Cancel
                </Button>
              </Grid>
              <Grid item xs="auto">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleConfirm}
                >
                  Confirm
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
  return [ConfirmationDialog, confirm];
};

export default useConfirm;
